import React from 'react';

import { MCButton } from 'src/components/basic';
import constants from 'src/constants';
import { permissions } from 'src/helpers';

import mainModel from '../model';
import model from './model';

const { PAGES, ACTIONS } = permissions;

const Buttons = ({ user, appointment, doctor, patient, params, loading }) => {
  return (
    <>
      {ACTIONS.APPOINTMENTS_CANCEL_BUTTON.checkActive(params) && (
        <MCButton
          {...ACTIONS.APPOINTMENTS_CANCEL_BUTTON.attributes}
          medium
          disabled={loading}
          onClick={() => {
            mainModel.showCancel(appointment, () => {
              appointment.data.status = constants.general.appointmentStatus.cancelled;
              model.setState({ appointment });
            });
          }}
        />
      )}
      {ACTIONS.APPOINTMENTS_CONFIRM_BUTTON.checkActive(params) && (
        <>
          <MCButton
            {...ACTIONS.APPOINTMENTS_CONFIRM_BUTTON.attributes}
            medium
            dark={appointment.data.status === constants.general.appointmentStatus.attended}
            disabled={
              loading || appointment.data.status === constants.general.appointmentStatus.attended
            }
            onClick={() => {
              model.updateStatus(appointment, constants.general.appointmentStatus.attended, () => {
                appointment.data.status = constants.general.appointmentStatus.attended;
                model.setState({ appointment });
              });
            }}
            label={'Attended'}
          />
          <MCButton
            {...ACTIONS.APPOINTMENTS_CONFIRM_BUTTON.attributes}
            medium
            dark={appointment.data.status === constants.general.appointmentStatus.not_attended}
            disabled={
              loading ||
              appointment.data.status === constants.general.appointmentStatus.not_attended
            }
            onClick={() => {
              model.updateStatus(
                appointment,
                constants.general.appointmentStatus.not_attended,
                () => {
                  appointment.data.status = constants.general.appointmentStatus.not_attended;
                  model.setState({ appointment });
                }
              );
            }}
            label={'Not attended'}
          />
        </>
      )}
      {ACTIONS.APPOINTMENTS_RESCHEDULE_BUTTON.checkActive(params) && (
        <MCButton
          {...ACTIONS.APPOINTMENTS_RESCHEDULE_BUTTON.attributes}
          type={'link'}
          medium
          to={PAGES.APPOINTMENTS_RESCHEDULE_PAGE.match(appointment.id)}
        />
      )}
      {ACTIONS.APPOINTMENTS_REBOOK_BUTTON.checkActive(params) && (
        <MCButton
          {...ACTIONS.APPOINTMENTS_REBOOK_BUTTON.attributes}
          medium
          type={'link'}
          to={
            user?.isClinic || user?.isManager
              ? permissions.PAGES.SCHEDULE_PAGE.path
              : user?.isDoctor
                ? permissions.PAGES.PATIENTS_APPOINTMENT_BOOK_PAGE.match(patient?.id)
                : permissions.PAGES.APPOINTMENTS_BOOK_PAGE.match(doctor?.username)
          }
        />
      )}
    </>
  );
};


Buttons.displayName = 'Buttons';

export default Buttons;
